export default "__VITE_ASSET__e0a0060c__"